<template>
  <div class="line-chart">
    <ApexChart
      type="line"
      :height="height"
      :options="chartOptions"
      :series="series"
      class="apex-chart"
    />
  </div>
</template>
<script setup>
import ApexChart from 'vue3-apexcharts';
import { computed } from 'vue';
import { commonChart, commonGrid, commonXAxisLabels, commonYAxis, buildCommonTooltip } from '@/Modules/Grafer/common/chartDefaults';
import { useChartColors } from '@/Modules/Grafer/useChartColors';

const props = defineProps({
  series: {
    type: Array,
    required: true
  },
  categories: {
    type: Array,
    default: () => []
  },
  height: {
    type: Number,
    default: 360
  },
  legendItems: {
    type: Array,
    default: () => []
  },
  colors: {  // Add colors prop that BaseChart passes
    type: Array,
    default: () => []
  }
});

const chartOptions = computed(() => ({
  chart: {
    type: 'line',
    height: props.height,
    ...commonChart
  },
  stroke: {
    curve: 'smooth',
    width: 2.5,
    lineCap: 'round'
  },
  colors: props.colors,  // Make this reactive
  markers: {
    size: 0,
    strokeWidth: 2,
    strokeColors: '#ffffff',
    hover: {
      size: 6,
      sizeOffset: 2
    }
  },
  grid: {
    ...commonGrid
  },
  dataLabels: { enabled: false },
  xaxis: {
    categories: props.categories,
    axisBorder: { show: false },
    axisTicks: { show: false },
    labels: {
      ...commonXAxisLabels
    }
  },
  yaxis: {
    ...commonYAxis
  },
  tooltip: buildCommonTooltip(props.legendItems, props.colors),
  legend: { show: false },
  responsive: [{
    breakpoint: 640,
    options: {
      chart: { height: 300 }
    }
  }]
}));
</script>
<style scoped>
.line-chart {
  position: relative;
}
/* Custom Tooltip Styles */
:global(.custom-tooltip) {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 120px;
}
:global(.tooltip-time) {
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 8px;
  font-size: 13px;
}
:global(.tooltip-item) {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
  font-size: 13px;
}
:global(.tooltip-item:last-child) {
  margin-bottom: 0;
}
:global(.tooltip-dot) {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}
:global(.tooltip-label) {
  color: #64748b;
  flex: 1;
}
:global(.tooltip-value) {
  font-weight: 600;
  color: #1e293b;
}
</style>